module.exports = __webpack_public_path__ + "static/img/vip-img1.b6ca40e.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/vip-img1.png
// module id = cbLz
// module chunks = 1